import Authorize from "components/Authorize";
import { isAuthorized } from "components/Authorize/authorizeUtil";
import { invoicePermissionProfile } from "components/Authorize/permissionProfiles/invoicePermissionProfile";
import InvoiceStatusDropdown from "features/invoice/shared/InvoiceStatusDropdown";
import { useUpdateVendorInvoiceStatusMutation } from "../vendorInvoiceSlice";
import { NoteEntityTypes } from "features/notes/notesConsts";
import { VendorInvoiceStatus, VendorInvoiceStatusesList } from "../vendorInvoiceConsts";

const StatusCell = ({ row, updateFunction, filled = false }) => {
    const canApprove = isAuthorized(invoicePermissionProfile.APPROVE_VENDOR_INVOICE)

    const getStatusList = (statusId) => {
        return (canApprove || statusId == VendorInvoiceStatus.APPROVED)
            ? VendorInvoiceStatusesList
            : VendorInvoiceStatusesList.filter(s => s.id != VendorInvoiceStatus.APPROVED);
    }

    const readonlyStatus = (statusId) => {
        const color = VendorInvoiceStatusesList?.find(s => s.id == statusId)?.color;
        return <div style={{ color }}>
            {VendorInvoiceStatusesList?.find(s => s.id == statusId)?.name}
        </div>
    };

    const services = row?.services ?? [];
    const vehicles = row?.vehicles ?? [];

    const hasAllActivitiesLinked = services.length > 0 && services.every(s => s.workOrderId);
    const hasLinkedVehicle = vehicles.length > 0;
    const hasQbVendor = !!row?.qbVendorId;
    const allQbAccountsMapped = services.length > 0 && services.every(s => s.qbAccountId);

    const problems = [];

    if (!hasQbVendor) {
        problems.push("Ensure a QuickBooks vendor is selected.");
    }
    
    if (!hasLinkedVehicle) {
        problems.push("Link the invoice to a vehicle.");
    }

    if (services.length === 0){
        problems.push("Link the invoice to the services.")
    }
    else{
        if (!hasAllActivitiesLinked) {
            problems.push("Link all services to their respective activities (Work Orders).");
        }

        if (!allQbAccountsMapped) {
            problems.push("Map all services to their respective QuickBooks accounts.");
        }
    }

    const disabledStatuses = problems.length > 0
        ? [VendorInvoiceStatus.APPROVED]
        : [];
    
    const disabledStatusMessage = problems.length > 0 ? (
        <div>
            <p>Before approving this invoice, please complete the following:</p>
            <ul>
            {problems.map((problem, index) => (
                <li key={index}>{problem}</li>
            ))}
            </ul>
        </div>
    ) : null;

    const isDisabled = (!!row?.statusId && row.statusId === VendorInvoiceStatus.SENT_TO_QB);

    return (
        <Authorize
            profile={invoicePermissionProfile.EDIT_VENDOR_INVOICE}
            readonlyComponent={
                <div>{readonlyStatus(row?.statusId)}</div>
            }
        >
            <InvoiceStatusDropdown
                invoiceId={row?.id}
                filled={filled}
                noteEntityType={NoteEntityTypes.STORAGEINVOICES}
                invoice={row}
                invoiceStatusList={getStatusList(row?.statusId)}
                updateMutation={useUpdateVendorInvoiceStatusMutation}
                updateFunction={updateFunction}
                disabledStatuses={disabledStatuses}
                disabledStatusMessage={disabledStatusMessage}
                isDisabled={isDisabled}
            />
        </Authorize>
    );
};

export default StatusCell;
